const footerCls = "_uihf1pnfiwc";
const spanCls = "_uihs1ox6r4t";
const titleCls = "_uihtmpy5lk";

export { footerCls, spanCls, titleCls };
import "./footer.style.linaria.module.css";
//# sourceMappingURL=footer.style.js.map
